<template>
    <div class="HomePageStyle">
        <!-- 中国元素图 -->
        <img class="leftChinesImg" src="../assets/images/decoleft.png" alt="">
        <img class="RighChinesImg" src="../assets/images/decoright.png" alt="">
        <top-component ref="topRef" :datalogintype="0"></top-component>
        <!-- <top-component-tch ref="topRef" v-if="logintype ==0"></top-component-tch> -->
        <!-- <div class="homepage-top">
            <div class="home-page-item">
                <div style="margin-right: 20px;cursor: pointer; display: flex; align-items: center;" @click="showerweima()" >
                    <img style="width:50px" src="../assets/images/erwe2.png" alt="">
                    <span style="display: block;font-family:'Alimama'">扫一扫</span>
                </div> 
            </div>
        </div> -->
        <!-- <div class="adv-dialog" v-if="advDialog">
            <div class="dialog_close" @click="advDialog=false"></div>
            <div class="dialog_container">
                <div style="position:relative ; margin: 0 auto;width: 70%; height: 100%;">
                    <div style="color: #fff; font-size: 20px; position: absolute; top:40%; line-height: 35px; text-indent: 2em; ">
                        {{wenzhiceshi}}
                    </div>
                </div>
            </div>
        </div> -->
        <!-- 右侧小程序二维码 -->
        <!-- <div class="wxcode ">
            <img src="../assets/images/gh_9466731f8652_258 (1).jpg" />
            <p>扫码体验移动选书</p>
        </div> -->
        <!-- 砸金蛋  -->
        <div class="wxcodeleft " v-if="showisjoin &&(adminState == 0 || adminState == 1)">
            <h3 style="color: #edd251;">金蛋来袭，砸出好礼</h3>
            <div
                style="width: 100%; height: 96%; display: flex; flex-direction:  column;  justify-content: space-evenly; align-items:flex-start; margin-bottom: 20px; color: #fff;">
                <div>主办方: <span style="font-size: 18px;font-weight: 700;">{{activitylist.org_name}}</span></div>
                <div>日期：<span style="font-size: 18px;">{{activitylist.datetime}}</span></div>
                <div>
                    开始时间：<span style="font-size: 18px;">{{activitylist.start_time}}</span>
                </div>
                <div>
                    结束时间：<span style="font-size: 18px;">{{activitylist.end_time}}</span>
                </div>
                <div style="width: 100%;
                    height: 60px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;">
                    <div style="width:100% ; margin: 0 auto; cursor: pointer; "> <button
                            @click="gosupplier(activitylist.org_name,activitylist.org_id)" class="activestate">{{
                            isStart }} <span>({{showisjoin1strin}})</span></button></div>
                    <div @click="zhongjiangjilu()"
                        style="width: 80px; height: 50px;color: #fff; cursor: pointer; font-size: 12px;  display: flex; flex-direction: column; justify-content: center; align-items: center;">
                        <img src="../assets//ggw_img/xiaoshubao1122.png" alt="中奖记录" title="中奖记录"
                            style="width:40px ; height: 40px;">
                        <div>中奖记录</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div style="width:1200px; height: 100%;">
            <img src="../assets/ggw_img/lunbo2025-9.png" style="width: 100%; height: 100%;" alt="">
        </div> -->
        <div id="content" class="container">
            <!-- <div style="width:100%; height: 100%;">
            <img src="../assets/ggw_img/lunbo2025-9.png" style="width: 100%; height: 100%;" alt="">
            </div> -->
            <div class="part-adv clearfixed">
                <div class="part-left">

                    <div class="adv-img" style="cursor: pointer;" @click="gosupplier('高等教育出版社有限公司',990)"><img
                            src="../assets/ggw_img/two_990gaodeng1.png" /></div>
                    <div class="adv-img" style="cursor: pointer;" @click="gosupplier('人民文学出版社',1235)"><img
                            src="../assets/ggw_img/renmingwenxue.png" /></div>
                </div>
                <div class="part-pageimg">
                    <el-carousel height="400px" :interval="3000">
                        <el-carousel-item>
                            <img src="../assets/ggw_img/lunbo-2026-3-new1.png" width="100%" height="100%"
                                style="cursor: pointer;" />
                        </el-carousel-item>
                        <!-- <el-carousel-item>
                            <img src="../assets/ggw_img/lunborenmingdaxue.png" width="100%" height="100%"
                                style="cursor: pointer;" @click="gosupplier('中国人民大学出版社',1390)" />
                        </el-carousel-item>
                        <el-carousel-item>
                            <img src="../assets/ggw_img/lunbuo1.jpg" width="100%" height="100%" style="cursor: pointer;"
                                @click="gosupplier('三新出版',6995)" />
                        </el-carousel-item> -->
                        <!-- <el-carousel-item>
                            <img src="../assets/ggw_img/lunbuo2.jpg" width="100%" height="100%" style="cursor: pointer;"
                                @click="newTESEtuijianTo(10138, '精品大码洋', 'ad99')" />
                        </el-carousel-item> -->
                        <!-- <el-carousel-item>
                            <img src="../assets/ggw_img/one_1460dalian.png" width="100%" height="100%" style="cursor: pointer;" @click="gosupplier('大连理工大学出版社 ',1460)" />
                        </el-carousel-item>
                        <el-carousel-item>
                            <img src="../assets/ggw_img/one_1390renming.jpg" width="100%" height="100%" style="cursor: pointer;" @click="gosupplier('中国人民大学出版社',1390)" />
                        </el-carousel-item>
                        <el-carousel-item>
                            <img src="../assets/ggw_img/one_1151huadong.jpg" width="100%" height="100%" style="cursor: pointer;" @click="gosupplier('华东师范大学出版社',1151)" />
                        </el-carousel-item>  -->
                    </el-carousel>
                </div>
                <div class="part-right">
                    <div class="adv-img" style="cursor: pointer;" @click="gosupplier('大连理工大学出版社有限公司',1460)"><img
                            src="../assets/ggw_img/dalianligong.jpg" /></div>
                    <div class="adv-img" style="cursor: pointer;" @click="gosupplier('中国科学技术出版社有限公司',879)"><img
                            src="../assets/ggw_img/two_879zhongguokexuejishu.jpg" /></div>
                </div>
            </div>
            <div class="part-adv2 clearfixed">
                <div class="adv-img" style="cursor: pointer;" @click="gosupplier('北京大学出版社有限公司',1367)"><img
                        src="../assets/ggw_img/two_1367beijindaxue.jpg" /></div>

                <div class="adv-img" style="cursor: pointer;" @click="gosupplier('上海社会科学院出版社有限公司',1138)"><img
                        src="../assets/ggw_img/shanghaishehuikexueyuan.jpg" /></div>

                <div class="adv-img" style="cursor: pointer;" @click="gosupplier('上海文艺出版社有限公司',1140)"><img
                        src="../assets/ggw_img/two_1140shanghaiwenyichubanse.jpg" /></div>

                <div class="adv-img" style="cursor: pointer;" @click="gosupplier('北京理工大学出版社有限责任公司',1196)">
                    <img src="../assets/ggw_img/two_1196beijinligong.jpg" />
                </div>
            </div>

            <!-- <div class="part-adv2 clearfixed">
                <div class="adv-img" style="cursor: pointer;" @click="gosupplier('人民文学出版社',1235)">
                    <img src="../assets/ggw_img/renmingwenxue.png" />
                </div>

                <div class="adv-img" style="cursor: pointer;" @click="gosupplier('知识产权出版社有限责任公司',868)"><img
                        src="../assets/ggw_img/two_868zhishicanquan.png" />
                </div>
                <div class="adv-img" style="cursor: pointer;" @click="gosupplier('北京理工大学出版社有限责任公司',1196)"><img
                        src="../assets/ggw_img/two_1196beijinligong.jpg" />
                </div>
                <div class="adv-img" style="cursor: pointer;" @click="gosupplier('华东师范大学出版社有限公司',1151)"><img
                        src="../assets/ggw_img/two_1151huadongshifan.jpg" />
                </div>
            </div> -->
            <div class="part-adv-cbs1">
                <div class="cbs-img"><img src="https://netpic.ytzhihui.com/pic/tch/cth/科学点亮生活.png"
                        @click="newTESEtuijianTo(10155, ' AI共生·智启未来', 'ad39')"
                        style="height:120px;width:1310px;cursor: pointer; " /></div>
            </div>
            <div class="part-adv-mini clearfixed">
                <!-- <div class="cbs-img" style="cursor: pointer;" v-for="(item,index) in randomizedList1" :key="item.id" @click="gosupplier(item.name,item.id)"><img v-lazy="item.img" /></div> -->
                <div class="cbs-img" style="cursor: pointer;" v-for="(item,index) in threelevelclassificationlist1"
                    :key="item.id" @click="gosupplier(item.name,item.id)"><img v-lazy="item.img" /></div>
            </div>
            <div class="part-adv-cbs2 clearfixed">
                <div class="cbs-img"><img src="https://netpic.ytzhihui.com/pic/tch/cth/阅读风向标.png"
                        @click="newTESEtuijianTo(10133, '热门好书', 'ad30')"
                        style="width:100%;height:100%; cursor: pointer;" /></div>
                <div class="cbs-img"><img src="https://netpic.ytzhihui.com/pic/tch/cth/让心灵贴近文学.png"
                        @click="newTESEtuijianTo(10134, '文学星推榜' ,'ad37')"
                        style="width:100%;height:100%; cursor: pointer;" /></div>
            </div>
            <div class="part-adv-mini clearfixed">
                <!-- <div class="cbs-img" style="cursor: pointer;" v-for="(item,index) in randomizedList2" :key="item.id" @click="gosupplier(item.name,item.id)"><img v-lazy="item.img" /></div>  -->
                <div class="cbs-img" style="cursor: pointer;" v-for="(item,index) in threelevelclassificationlist5"
                    :key="item.id" @click="gosupplier(item.name,item.id)"><img v-lazy="item.img" /></div>
            </div>
            <!-- <div class="part-cbs-book clearfixed">
                <div class="cbs-book-wrap clearfixed">
                    <div class="cbs-img">
                        <img src="https://d.cxstar.com/img/ads/K9.jpg" style="width: 232px;height:345px;" />
                    </div>
                    <div class="cbs-book-box clearfixed">
                        <img src="https://d.cxstar.com/img/ads/G51.jpg" />
                        <img src="https://d.cxstar.com/img/ads/G52.jpg" />
                        <img src="https://d.cxstar.com/img/ads/G53.jpg" />
                        <img src="https://d.cxstar.com/img/ads/G54.jpg" />
                        <img src="https://d.cxstar.com/img/ads/G55.jpg" />
                        <img src="https://d.cxstar.com/img/ads/G56.jpg" />
                    </div>
                </div>
                <div class="cbs-book-wrap clearfixed">
                    <div class="cbs-img">
                        <img src="https://d.cxstar.com/img/ads/H1.jpg" style="width: 232px;height:345px;" />
                    </div>
                    <div class="cbs-book-box clearfixed">
                        <img src="https://d.cxstar.com/img/ads/H11.jpg" />
                        <img src="https://d.cxstar.com/img/ads/H12.jpg" />
                        <img src="https://d.cxstar.com/img/ads/H13.jpg" />
                        <img src="https://d.cxstar.com/img/ads/H14.jpg" />
                        <img src="https://d.cxstar.com/img/ads/H15.jpg" />
                        <img src="https://d.cxstar.com/img/ads/H16.jpg" />
                    </div>
                </div>
            </div> -->
            <!-- 2高校馆、图书馆、出版社、地方版现货 -->
            <div class="University-Library">
                <a href="javascript:;" v-for="(item, index) in RuKouData" :key="index"
                    @click="isloginRouter(item.link)">
                    <img class="University-Library-Img" :key="index" :src="item.img" alt="" />
                </a>
                <a href="javascript:;" @click="isRouterHasOpt('LocalSpot', 'activitytag', '10118')">
                    <img class="University-Library-Img" src="../assets/images/Newimg7.png" alt="">
                </a>
            </div>
            <div class="Book">
                <div class="common-title">
                    <span class="tit_t">地方版出版社</span>
                </div>
                <el-row class="bookTuijian">
                    <el-col :span="18" class="BookTuijian-el-co18" style="padding-right:5px;">
                        <div class="grid-content-one">
                            <img src="../assets/images/dfb.jpg" width="420px" height="300px"
                                style="margin:10px 10px 0 10px;" alt="" @click="ShowSocietys()">
                            <img src="../assets/images/tsg.jpg" width="420px" height="300px"
                                style="margin:10px 10px 0 0px;" alt="" @click="ShowNational()">
                            <div class="content-bottom">
                                <div class="adress-content-co14">
                                    <div v-for="(item, index) in mainlyPlace" :key="index" class="adress-listStyleDiv"
                                        id="ID" @click="DifangAdress(item.id)">
                                        <span>{{ item.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="6" class="BookTuijian-el-co6">
                        <div class="xiaoliagnTitle"><span class="leftChuBan">供应商排行榜</span>
                            <span class="RightMore" @click="isloginRouter('PubTop')">更多</span>
                        </div>
                        <div class="DouckImgWrap">
                            <div class="DouckImg" v-for="(item, index) in pubTopArr.slice(0, 8)" :key="index"
                                @click="ShowPubLic(item.columnIndex, 'pubid', item.lable, 'top',item.remark)">
                                <div class="DouckImgItem">
                                    <div v-if="index === 0" class="top_item_rank top_item_rank_1">
                                        <img src="../assets/images/TopOne.png" alt="">
                                        <span class="top_item_rank_top">TOP</span>
                                        <span class="top_item_rank_num">01</span>
                                    </div>
                                    <div v-else-if="index === 1" class="top_item_rank top_item_rank_1">
                                        <img src="../assets/images/TopTwo.png" alt="">
                                        <span class="top_item_rank_top">TOP</span>
                                        <span class="top_item_rank_num">02</span>
                                    </div>
                                    <div v-else-if="index === 2" class="top_item_rank top_item_rank_1">
                                        <img src="../assets/images/TopThree.png" alt="">
                                        <span class="top_item_rank_top">TOP</span>
                                        <span class="top_item_rank_num">03</span>
                                    </div>
                                    <div v-else style="text-align: center;" class="item_not">
                                        <span v-if="Number(index) < 9">0{{ index + 1 }}</span>
                                        <span v-else>{{ index + 1 }}</span>
                                    </div>
                                </div>
                                <!-- <img class="biaoshi cbs_img" :src="item.imageUrl" alt=""> -->
                                <!-- <img class="biaoshi" :src="item.imageUrl || '../assets/images/default_fm.png'" alt=""> -->
                                <span class="nameStyle1" :title="item.lable">{{ item.lable }}</span>

                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <!-- <el-carousel class="banner-box" height="600px" :interval="3000">
                <el-carousel-item>
                    <img src="../assets/gxg_img/gxg_01.png" @click="TESEtuijianTo('10147', '师范教育精选', 'ad91')"
                        style="cursor: pointer;" />
                </el-carousel-item>
                <el-carousel-item>
                    <img src="../assets/gxg_img/gxg_02.png" @click="TESEtuijianTo('10146', '计算机精选', 'ad92')"
                        style="cursor: pointer;" />
                </el-carousel-item>
                <el-carousel-item>
                    <img src="../assets/gxg_img/gxg_03.png" @click="TESEtuijianTo('10153', '理工科精选', 'ad93')"
                        style="cursor: pointer;" />
                </el-carousel-item>
                <el-carousel-item>
                    <img src="../assets/gxg_img/gxg_04.png" @click="TESEtuijianTo('10154', '马工程必选', 'ad94')"
                        style="cursor: pointer;" />
                </el-carousel-item>
                <el-carousel-item>
                    <img src="../assets/gxg_img/gxg_05.png" @click="TESEtuijianTo('10155', '农林学精选', 'ad95')"
                        style="cursor: pointer;" />
                </el-carousel-item>
                <el-carousel-item>
                    <img src="../assets/gxg_img/gxg_06.png" @click="TESEtuijianTo('10156', '专业医学', 'ad96')"
                        style="cursor: pointer;" />
                </el-carousel-item>
                <el-carousel-item>
                    <img src="../assets/gxg_img/gxg_07.png" @click="TESEtuijianTo('10157', '经管必选', 'ad97')"
                        style="cursor: pointer;" />
                </el-carousel-item>
            </el-carousel> -->

            <div class="Book" v-if=" showshaoer=='19676897116832911542128149846863'">
                <div class="common-title">
                    <span class="tit_t">童书类</span>
                    <div class="listwrap ggg_list">
                        <i class="icon iconfont iconarrowleft" @click="preList('ulWrap0')"></i>
                        <div class="ul_wrap">
                            <ul class="ulbox" id="ulWrap0">
                                <li v-for="(item, i) in childrenArr" :key="i" @mouseenter="getRemsList(item.gid, i)"
                                    :class="{ 'active': childrenActive == i }"
                                    @click="TESEtuijianTo(10132, item.tab, 'ad' + (19 + i))">
                                    <span style="margin-top: 5px" v-if="item.tab.length >= 10">
                                        <span>{{ test(item, 0) }}</span><br />
                                        <span>{{ test(item, 1) }}</span><br />
                                    </span>
                                    <span style="line-height:40px;" v-if="item.tab.length < 10">
                                        <span>{{ item.tab }}</span><br />
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <i class="icon iconfont iconarrowright" @click="nextList('ulWrap0')"></i>
                    </div>
                </div>
                <div class="bookTuijian">
                    <div class="BookTuijian-el-co18">
                        <div class="grid-content-one">
                            <div class="grid-content-two" v-for="(item, index) in childrenListArr" :key="index"
                                @click="BookTuiClickRowid(item.goodsId, 'ad' + (19 + childrenActive))">
                                <div class="imgDivAdd">
                                    <img :src="item.imageUrl || ''" @error="errorHandler" alt="">
                                </div>
                                <p class="grid-content-two-title">{{ item.title }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="Book">
                <div class="common-title">
                    <span class="tit_t">公共馆</span>
                    <div class="listwrap ggg_list">
                        <i class="icon iconfont iconarrowleft" @click="preList('ulWrap')"></i>
                        <div class="ul_wrap">
                            <ul class="ulbox" id="ulWrap">
                                <li v-for="(item, i) in tsArr" :key="i" @mouseenter="getRemList(item.gid, i)"
                                    :class="{ 'active': tsActive == i }"
                                    @click="TESEtuijianTo(item.gid, item.tab, 'ad' + (29 + i))">
                                    <span style="margin-top: 5px" v-if="item.tab.length >= 10">
                                        <span>{{ test(item, 0) }}</span><br />
                                        <span>{{ test(item, 1) }}</span><br />
                                    </span>
                                    <span style="line-height:40px;" v-if="item.tab.length < 10">
                                        <span>{{ item.tab }}</span><br />
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <i class="icon iconfont iconarrowright" @click="nextList('ulWrap')"></i>
                    </div>
                </div>
                <div class="bookTuijian">
                    <div class="BookTuijian-el-co18">
                        <div class="grid-content-one">
                            <div class="grid-content-two" v-for="(item, index) in tsListArr" :key="index"
                                @click="BookTuiClickRowid(item.goodsId, 'ad' + (29 + tsActive))">
                                <div class="imgDivAdd">
                                    <img :src="item.imageUrl || ''" @error="errorHandler" alt="">
                                </div>
                                <p class="grid-content-two-title">{{ item.title }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 热门推荐 -->
            <div class="Book">
                <div class="common-title">
                    <span class="tit_t">高校馆</span>
                    <div class="listwrap gxg_list">
                        <i class="icon iconfont iconarrowleft" @click="preList('ulWrap2')"></i>
                        <div class="ul_wrap">
                            <ul class="ulbox" id="ulWrap2">
                                <li v-for="(item, i) in rmArr" :key="i" @mouseenter="getRmList(item.gid, i)"
                                    :class="{ 'active': rmActive == i }"
                                    @click="TESEtuijianTo(item.gid, item.tab, 'ad' + (39 + i))">
                                    {{ item.tab }}
                                </li>
                            </ul>
                        </div>
                        <i class="icon iconfont iconarrowright" @click="nextList('ulWrap2')"></i>
                    </div>
                </div>
                <el-row :gutter="10" class="bookTuijian">
                    <el-col :span="18" :xs="24" class="BookTuijian-el-co18">
                        <div class="grid-content-one">
                            <div class="grid-content-two" v-for="(item, index) in rmListArr" :key="index"
                                @click="BookTuiClickRowid(item.goodsId, 'ad' + (39 + rmActive))">
                                <div class="imgDivAdd">
                                    <img :src="item.imageUrl || ''" @error="errorHandler" alt="">
                                </div>
                                <p class="grid-content-two-title">{{ item.title }}</p>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="6" :xs="24" class="BookTuijian-el-co6">
                        <div class="xiaoliagnTitle"><span class="leftChuBan">热门推荐排行</span>
                            <!-- <span class="RightMore">更多</span>  -->
                        </div>
                        <div class="DouckImgWrap">
                            <div class="DouckImg" v-for="(item, index) in remTopArr.slice(0, 8)" :key="index"
                                @click="BookTuiClickRowid(item.goodsId, 'top')">
                                <div class="DouckImgItem">
                                    <div v-if="index === 0" class="top_item_rank top_item_rank_1">
                                        <img src="../assets/images/TopOne.png" alt="">
                                        <span class="top_item_rank_top">TOP</span>
                                        <span class="top_item_rank_num">01</span>
                                    </div>
                                    <div v-else-if="index === 1" class="top_item_rank top_item_rank_1">
                                        <img src="../assets/images/TopTwo.png" alt="">
                                        <span class="top_item_rank_top">TOP</span>
                                        <span class="top_item_rank_num">02</span>
                                    </div>
                                    <div v-else-if="index === 2" class="top_item_rank top_item_rank_1">
                                        <img src="../assets/images/TopThree.png" alt="">
                                        <span class="top_item_rank_top">TOP</span>
                                        <span class="top_item_rank_num">03</span>
                                    </div>
                                    <div v-else style="text-align: center;" class="item_not">
                                        <span v-if="Number(index) < 9">0{{ index + 1 }}</span>
                                        <span v-else>{{ index + 1 }}</span>
                                    </div>
                                </div>
                                <img class="biaoshi" :src="item.imageUrl || '../assets/images/default_fm.png'" alt="">
                                <span class="nameStyle">{{ item.title }}</span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div>
                <div style="color: #2b2725;font-size: 20px; font-weight: 600;padding:10px 0 ;">数智服务生态</div>
                <div style="width: 100%; height: 260px; cursor: pointer;" @click="goxuanchuan()">
                    <img src="../assets/ggw_img/shuzhihua(1).png" style="width: 100%; height: 100%;" alt="">
                </div>
            </div>
            <!-- <div class="Diversification">
                <div class="ad_wrap clearfixed">
                    <div class="ad_left">
                        <div class="common-title">周边推荐</div>
                        <div class="zbtj_list">
                            <div class="SideTuijian-grid-content" v-for="(item, index) in SideData" :key="index"
                                @click="BookTuiClickSide(item)">
                                <img :src="item ? item.imageUrl : require('../assets/images/shang-pin.jpg')" alt="">
                                <div class="SideTuijian-grid-title">{{ item ? item.lable : '暂无商品' }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="ad_right">
                        <div class="common-title">多元化产品</div>
                        <div class="prolist">
                            <div class="grid-content" v-for="(item, index) in PublicData" :key="index"
                                @click="isloginRouter(item.link)">
                                <div class="iconfont duoyuanStyle" :class="item.icon"></div>
                                <div class="DiversiDiv">{{ item.name }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->


        </div>
        <div>
            <el-dialog style="z-index: 100000;" :visible.sync="erweima" width="20%" :show-footer="false"
                class="centered-dialog">
                <div
                    style="display:flex ; justify-content: center; align-items: center; flex-direction: column; width: 100%; height: 100%;">
                    <img alt="example" style="width: 225px; height: 225px;"
                        src="../assets/images/gh_9466731f8652_258 (1).jpg" />
                    <div style="font-size:18px; margin-top: 15px;font-family: serif;">微信扫描二维码</div>
                </div>
            </el-dialog>
        </div>
        <!-- <div class="sidenavigationbar">
            <div class="sidenavigationbaritem"  @click="toJangou()" >
                <img style="width:50px" src="../assets/images/Newplanet.png" alt="">
                <span style="display: block;font-family:'Alimama'">读者荐购</span>
            </div>
            <div class="sidenavigationbaritem"  @click="paperEbookHandle()" >
                <img style="width:50px" src="../assets/images/Newfav.png" alt="">
                <span style="display: block;font-family:'Alimama'">纸电同步</span>
            </div>
            <div class="sidenavigationbaritem"  @click="showerweima()" >
                <img style="width:50px" src="../assets/images/erwe2.png" alt="">
                <span style="display: block;font-family:'Alimama'">移动端选书</span>
            </div>
            <div class="sidenavigationbaritem"   @click="zhongjiangjilu()" >
                <img style="width:50px; height: 50px;" title="中奖记录" src="../assets/ggw_img/xiaoshubao1122.png" alt="">
                <span style="display: block;font-family:'Alimama';">中奖记录</span>
            </div>
            <div class="sidenavigationbaritem"   @click="ProblemReport()" >
                <img style="width:50px; height: 50px;" title="问题反馈" src="../assets/images/fankui.jpg" alt="">
                <span style="display: block;font-family:'Alimama';">问题反馈</span>
            </div>
          </div> -->
        <bottom-component :datalogintype="0" ref="footer"></bottom-component>
    </div>
</template>

<script>
    import { Loading, button } from "element-ui";
    import BottomComponent from './Components/BottomComponent.vue'
    import TopComponent from './Components/TopComponentcopy.vue'
    // import TopComponentTch from './Components/TopComponentTch.vue'
    import popup from "../common/plugin/dialog/index";
    import ImproveInfo from "../components/improveInfo.vue";
    import Axios from '@/api/diyaxios'
    import { actionselect, actionindexData, actionscroll, featuredrecommendationranking, goldeggsmashingactivity } from '@/api/pages'
    import { bookList } from '@/dataJson/hompagebookdata2.js'
    // import { bookList } from '@/dataJson/bookData.js'

    import Cookies from 'js-cookie'
    import { Base64 } from 'js-base64'
    import { insertPoint } from '@/api/insertPoints'   //添加埋点
    export default {
        name: 'HomePage',
        data() {
            return {
                erweima: false,
                previewImage: '',
                logintype: Cookies.get('logintype'),
                // 高校馆、图书馆、出版社、地方版现货
                RuKouData: [
                    { img: require('../assets/images/Newimg8.png'), link: 'commonLibrary' },
                    { img: require('../assets/images/Newimg2.png'), link: 'SchoolLibrary' },
                    { img: require('../assets/images/Newimg9(1).png'), link: 'PublisherBook' },
                    //   { img: require('../assets/images/Newimg7.png'), link: 'LocalSpot' }
                ],
                // 三级广告位
                threelevelclassificationlist1: [
                    { name: '江苏译林出版社有限公司', id: 1083, img: require('../assets/ggw_img/jiangsuyilin.jpg') },
                    { name: '浙江文艺出版社有限公司', id: 1183, img: require('../assets/ggw_img/zejiangwenyi.png') },
                    { name: '浙江大学出版社有限责任公司', id: 1178, img: require('../assets/ggw_img/zejiangdaxue.jpg') },
                    { name: '中国人民大学出版社有限公司', id: 1390, img: require('../assets/ggw_img/zhongguorenmin.png') },
                    { name: '人民出版社', id: 1233, img: require('../assets/ggw_img/renminchubanse.jpg') },

                    { name: '华东师范大学出版社有限公司', id: 1151, img: require('../assets/ggw_img/huadongshifan.jpg') },
                    { name: '武汉大学出版社有限责任公司', id: 1259, img: require('../assets/ggw_img/wuhandaxuechubanse.jpeg') },

                    { name: '知识产权出版社有限责任公司', id: 868, img: require('../assets/ggw_img/zhishicanquan.png') },
                    { name: '山西人民出版社有限责任公司', id: 1416, img: require('../assets/ggw_img/shanxirenming.jpg') },
                    { name: '人民邮电出版社有限公司', id: 854, img: require('../assets/ggw_img/renmingyoudian.png') },
                    { name: '中国社会科学出版社', id: 1272, img: require('../assets/ggw_img/zhongguosehuikexue.jpg') },
                    { name: '社会科学文献出版社', id: 1245, img: require('../assets/ggw_img/sehuikexuewenxian.png') },
                    


                    // { name: '重庆指文化行文化传播有限公司', id: 6747, img: require('../assets/ggw_img/secondarychongqingzhi.jpg') },
                    // { name: '人民出版社', id: 1233, img: require('../assets/ggw_img/renminchubanse.jpg') },
                    // { name: '国防工业出版社', id: 851, img: require('../assets/ggw_img/sanjiguofanggongye.jpg') },
                    // { name: '立信会计出版社有限公司', id: 1156, img: require('../assets/ggw_img/lixinkuaiji.jpg') },
                    // { name: '上海书画出版社有限公司', id: 1159, img: require('../assets/ggw_img/shanghaishuhua.jpg') },
                    // { name: '人民邮电出版社有限公司', id: 854, img: require('../assets/ggw_img/renmingyoudianchubanse.png') },
                    // { name: '大连理工大学出版社有限公司', id: 1460, img: require('../assets/ggw_img/sanjidalianligong.png') },
                    // { name: '长江文艺出版社有限公司', id: 1205, img: require('../assets/ggw_img/sanjichangjiangwenyi.jpg') },
                    //  { name: '中国社会科学出版社', id: 1272,img: require('../assets/ggw_img/zhongguosehuikexue.jpg')},
                    //  { name: '江苏凤凰出版社有限公司', id: 1101 ,img: require('../assets/ggw_img/jiangsufenghuangchubanse.png')},
                    //  { name: '江苏凤凰美术出版社有限公司', id: 1096 ,img: require('../assets/ggw_img/jiangsufenghuangmeisu.jpg')},

                    //  { name: '人民邮电出版社有限公司', id: 854 ,img: require('../assets/ggw_img/renmingyoudianchubanse.png')},
                    //  { name: '中国科技出版传媒股份有限公司', id: 1229 ,img: require('../assets/ggw_img/zhongguokeji.png')},
                    //  { name: '中国建筑出版传媒有限公司', id: 910 ,img: require('../assets/ggw_img/zhonguojianzhu.jpg')},

                    //  { name: '华中科技大学出版社有限责任公司', id: 1220 ,img: require('../assets/ggw_img/huazhongkeji.png')},
                    //  { name: '知识产权出版社有限责任公司', id: 868 ,img: require('../assets/ggw_img/zhishicanquan.png')},
                    //  { name: '中国政法大学出版社有限责任公司', id: 932 ,img: require('../assets/ggw_img/zhongguozhengfa.jpg')},

                ],
                displayList: [], // 当前显示的数据列表

                threelevelclassificationlist5: [
                    

                    { name: '北京磨铁文化集团股份有限公司', id: 850, img: require('../assets/ggw_img/beijinmotie.jpg') },
                    { name: '上海浪花朵朵企业发展有限公司', id: 7163, img: require('../assets/ggw_img/langhuaduoduo.png') },
                    { name: '读客文化股份有限公司', id: 6282, img: require('../assets/ggw_img/dukewenhua.jpg') },
                    { name: '浙江人民出版社有限公司', id: 1180, img: require('../assets/ggw_img/zejiangrenmin.png') },

                    { name: '中国科技出版传媒股份有限公司', id: 1229, img: require('../assets/ggw_img/zhongguokeji.png') },
                    { name: '南京大学出版社有限公司', id: 1090, img: require('../assets/ggw_img/nanjindaxue.png') },
                    { name: '南京东南大学出版社有限公司', id: 1084, img: require('../assets/ggw_img/nanjindongnandaxue.png') },
                    { name: '上海书画出版社有限公司', id: 1159, img: require('../assets/ggw_img/shanghaishuhua.jpg') },

                    // { name: '浙江文艺出版社有限公司', id: 1183, img: require('../assets/ggw_img/zejiangwenyi.png') },
                    // { name: '重庆出版集团图书发行有限公司', id: 825, img: require('../assets/ggw_img/three_825chongqingchuban.png') },
                    // { name: '青岛出版社有限公司', id: 1118, img: require('../assets/ggw_img/qingdaochubanjituan.jpg') },
                    // { name: '江苏凤凰出版社有限公司', id: 1101, img: require('../assets/ggw_img/jiangsufenghuangchubanse.png') },
                    // { name: '江苏译林出版社有限公司', id: 1083, img: require('../assets/ggw_img/jiangsuyilin.png') },
                    // { name: '江苏凤凰美术出版社有限公司', id: 1096, img: require('../assets/ggw_img/jiangsufenghuangmeisu.jpg') },
                    // { name: '北岳文艺出版社有限责任公司', id: 1418, img: require('../assets/ggw_img/three_1418beiyuerenyi.png') },



                    // { name: '江苏凤凰出版社有限公司', id: 1101, img: require('../assets/ggw_img/jiangsufenghuangchubanse.png') },
                    // { name: '新华文轩出版传媒股份有限公司武汉分公司', id: 790, img: require('../assets/ggw_img/xinhuawenxuan.jpg') },
                    // { name: '后浪出版咨询（北京）有限责任公司', id: 1005, img: require('../assets/ggw_img/beijinhoulang.jpg') },
                    // { name: '北京磨铁文化集团股份有限公司', id: 850, img: require('../assets/ggw_img/beijinmotie.jpg') },
                    // { name: '北岳文艺出版社有限责任公司', id: 1418, img: require('../assets/ggw_img/beiyuewenyi.png') },
                    // { name: '重庆出版社', id: 825, img: require('../assets/ggw_img/chongqingchuban.png') },
                    // { name: '浙江人民出版社有限公司', id: 1180, img: require('../assets/ggw_img/zejiangrenmin.jpg') },
                    //  { name: '辽宁科学技术出版社有限责任公司', id: 1458 ,img: require('../assets/ggw_img/liaoninkexuejishu.png')}, 
                    //  { name: '山东人民出版社有限公司', id: 1113 ,img: require('../assets/ggw_img/shandongrenmin.jpg')},
                    //  { name: '山西人民出版社有限责任公司', id: 1416 ,img: require('../assets/ggw_img/shanxirenmin.png')},
                    //  { name: '浙江文艺出版社有限公司', id: 1183 ,img: require('../assets/ggw_img/zejiangwenyi.png')},
                    //  { name: '江苏译林出版社有限公司', id: 1083 ,img: require('../assets/ggw_img/jiangsuyilin.png')},
                    //  { name: '江苏凤凰文艺出版社有限公司', id: 1088 ,img: require('../assets/ggw_img/jiangsufenghuangwenyi.png')},
                    //  { name: '北京浪花朵朵文化传播有限公司', id: 7163 ,img: require('../assets/ggw_img/beijinlanghuaduoduo.jpg')},
                    //  { name: '新华文轩出版传媒股份有限公司武汉分公司', id: 790 ,img: require('../assets/ggw_img/xinhuawenxuan.jpg')},
                    //  { name: '北京文通天下图书有限公司', id: 777 ,img: require('../assets/ggw_img/beijinwenxuan.jpg')},
                    //  { name: '北京蝠池文化传媒有限公司', id: 6724 ,img: require('../assets/ggw_img/beijinfuci.jpg')},
                ],
                displayList1: [], // 当前显示的数据列表

                //地方版出版社
                mainlyPlace: [
                    { name: '地方人民社', id: "3" },
                    { name: '地方科技社', id: "0" },
                    { name: '地方文艺社', id: "6" },
                    { name: '地方美术社', id: "5" },
                    { name: '地方少儿社', id: "1" },
                    { name: '地方大学社', id: "8" },
                    { name: '地方教育社', id: "2" },
                    { name: '地方城市文化社', id: "4" },
                    { name: '地方民族古籍社', id: "7" },
                ],
                wenzhiceshi: '您现在看到的是24年春季线上图采会的内部测试版，还有很多内容待完善，当前仅针对三新内部员工做测试用，本网址也不是最终线上的地址，所以请不要将本网址对外公开，感谢您的合作。',
                pubTopArr: [],//出版社排行
                tsListArr: [],//特色分类数据
                childrenArr: [//公共馆
                    { tab: '0-3岁', gid: 100001 },
                    { tab: '4-12岁', gid: 100002 },
                    { tab: '13-18岁', gid: 100003 },
                ],
                tsArr: [//公共馆
                    { tab: '热门好书', gid: 10133 },
                    { tab: '史地万象', gid: 10128 },
                    { tab: '成长力量馆', gid: 10129 },
                    { tab: '艺术美学', gid: 10130 },
                    { tab: '烟火生活', gid: 10131 },
                    { tab: '童心绘梦坊', gid: 10132 },
                    { tab: '文学星推榜', gid: 10134 },
                    { tab: '红色信仰', gid: 10135 },
                    // { tab: '抗战80周年', gid: 10136 },
                ],
                tsActive: 0,//特色推荐下标
                rmListArr: [],//特色分类数据
                childrenActive: 0,
                childrenListArr: [],
                rmArr: [//高校馆
                    // { tab: ' 新技术应用 ', gid: 10144 },
                    { tab: '精品典藏', gid: 10156 },
                    { tab: ' 经济视界 ', gid: 10145 },
                    { tab: ' 计算机技术 ', gid: 10146 },
                    { tab: ' 以心育人 ', gid: 10147 },
                    { tab: ' 艺术博览 ', gid: 10149 },
                    { tab: ' 电气信息 ', gid: 10150 },
                    { tab: ' 空铁智行 ', gid: 10151 },
                    { tab: ' 工科新知 ', gid: 10152 },
                    { tab: '农环科学', gid: 10153 },
                    { tab: ' 医学健康', gid: 10154 },
                    { tab: 'AI共生·智启未来', gid: 10155 },
                    
                ],
                rmActive: 0,
                remTopArr: [],//热门推荐排行
                SideData: [],//特色推荐
                // 多元化产品
                PublicData: [
                    { icon: 'iconpaper', name: '采编一体化', link: 'ProductCiaabian' },
                    { icon: 'iconbook', name: '田田阅读', link: 'ProductTiantian' },
                    { icon: 'iconbox', name: '云田购', link: 'ProductYun' },
                    { icon: 'iconlibrary', name: '智慧图书馆', link: 'ProductZhihui' },
                    { icon: 'iconbook1', name: '图书馆服务', link: 'ProductFuwu' },
                    { icon: 'iconcabinet', name: '图书消毒柜', link: 'ProductXiaodugui' },
                ],
                advDialog: true,
                showLoading: null,
                activitylist: null,
                showisjoin: false,
                isStart: '',
                showisjoin1strin: '',
                showshaoer: Cookies.get('orgGid'),
                adminState: Cookies.get("adminState"),
            }
        },
        components: {
            BottomComponent,
            TopComponent,
            // TopComponentTch,
            Loading,
            button
        },
        created() {
            JSON.parse(localStorage.getItem('user')).source
        },
        computed: {
            randomizedList1() {
                return this.threelevelclassificationlist1.slice().sort(() => Math.random() - 0.5);
            },
            randomizedList2() {
                return this.threelevelclassificationlist5.slice().sort(() => Math.random() - 0.5);
            },
        },
        mounted() {
            let vm = this;
            // vm.getgoldeggsid()   // z砸金蛋活动场次
            vm.mysource()
            vm.ApiData();
            //特色推荐列表
            // vm.getRemList();
            vm.getRemTop();//热门推荐
            //高校馆、公共馆  
            vm.$nextTick(() => {
                document.getElementById('ulWrap0').style.width = vm.getUlWidth('ulWrap0') + 10 + 'px';
                document.getElementById('ulWrap').style.width = vm.getUlWidth('ulWrap') + 10 + 'px';
                document.getElementById('ulWrap2').style.width = vm.getUlWidth('ulWrap2') + 'px';
            });
            // 获取并解析 localStorage 中的 'user' 数据
            const user = JSON.parse(localStorage.getItem('user'));
            // // 判断 soure 是否等于 2
            if (user && user.source == 2) {
                // 跳转到另一个页面
                vm.$router.push('/preheatingcountdown');   // 跳转到倒计时页面
            }
        },
        methods: {
            mysource() {
                // localStorage.setItem('logintype',0)
                Cookies.set('logintype', 0)
            },
            showerweima(file) {
                this.erweima = !this.erweima
            },
            errorHandler(event) {
                event.target.classList.add('error')
            },
            preList(id) {
                let vm = this;
                document.getElementById(id).style.marginLeft = 0;
            },
            nextList(id) {
                let vm = this,
                    listwidth = document.getElementById(id).parentNode.clientWidth;
                document.getElementById(id).style.marginLeft = (listwidth - vm.getUlWidth(id)) + 'px';
            },
            getUlWidth(id) {
                let liW = 0,
                    $id = document.getElementById(id);
                for (var i = 0; i < $id.getElementsByTagName('li').length; i++) {
                    liW += Math.ceil($id.getElementsByTagName('li')[i].clientWidth); //向上取整，2.3 => 3
                }
                return liW;
            },
            test(index, nstate) {
                if (nstate == '0') {
                    return index.tab.split('，')[0];
                }
                else {
                    return index.tab.split('，')[1];
                }
            },
            // 读者荐购
            toJangou() {
                if (Cookies.get('passPort') && Cookies.get('passWord')) {
                    window.open(`http://rmd.ytzhihui.com/login.html?passPort=${Cookies.get('passPort')}&orgGid=${Cookies.get('orgGid')}&passWord=${Base64.encode(Cookies.get('passWord'))}`);
                    // window.open(`http://localhost/login.html?passPort=${Cookies.get('passPort')}&orgGid=${Cookies.get('orgGid')}&passWord=${Base64.encode(Cookies.get('passWord'))}`);
                } else {
                    window.open(`http://rmd.ytzhihui.com/login.html`)
                }
            },
            //纸电同步跳转
            paperEbookHandle() {
                if (Cookies.get('token')) {
                    let params = {
                        goodsType: 2,
                        gid: 0
                    };
                    const { href } = this.$router.resolve({
                        name: 'LookPublishingPagesType',
                        query: {
                            obj: JSON.stringify(params)
                        }
                    });
                    window.open(href, '_blank');
                } else {
                    this.$router.push({ name: 'Login' });
                }
            },
            // 进入直播
            ComeLive() {
                window.open('http://www.cxznlibwx.com:8090', '_blank');
            },
            // 中奖记录
            zhongjiangjilu() {
                if (Cookies.get('token')) {
                    const { href } = this.$router.resolve({
                        name: 'myPrice',
                    });
                    window.open(href, '_blank');
                } else {
                    this.$router.push({ name: 'Login' });
                }
            },
            //客户问题反馈
            ProblemReport() {
                if (Cookies.get("token")) {
                    const { href } = this.$router.resolve({
                        name: 'ProblemReport',
                    });
                    window.open(href, '_blank');
                } else {
                    this.$router.push({ name: "Login" });
                }
            },
            // 获取·砸金蛋活动以及·是否有权限砸金蛋
            async getgoldeggsid() {
                if (Cookies.get('token')) {
                    let data = {
                        userid: Cookies.get('UserID')
                    }
                    let res = await goldeggsmashingactivity(data)
                    if (res.code == '200') {
                        if (res.data != null) {
                            this.isStart = this.checkTimeRange(res.data.start_time, res.data.end_time)
                            let datetime = this.formatTimestamp(res.data.start_time, 1)
                            res.data.start_time = this.formatTimestamp(res.data.start_time, 2)
                            res.data.end_time = this.formatTimestamp(res.data.end_time, 2)
                            if (res.data.isjoin == 0) {
                                this.showisjoin1strin = '未参与'
                            } else {
                                this.showisjoin1strin = '已参与'
                            }
                            this.showisjoin = true
                            this.activitylist = res.data
                            this.$set(this.activitylist, 'datetime', datetime);
                        } else if (res.data == null) {
                            this.showisjoin = false
                        }
                    } else {
                        this.showisjoin = false
                    }
                } else {

                }
            },
            checkTimeRange(start_time, end_time) {
                const startDate = new Date(start_time);
                const endDate = new Date(end_time);
                const currentDate = new Date();
                if (currentDate >= startDate && currentDate <= endDate) {
                    return "进行中";
                } else if (currentDate < startDate) {
                    return "未开始";
                } else {
                    return "已结束";
                }
            },
            formatTimestamp(timestamp, how) {
                const dateObj = new Date(timestamp);
                const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
                const day = dateObj.getDate().toString().padStart(2, '0');
                const time = timestamp.split(' ')[1];
                const [hour, minute] = time.split(':').slice(0, 2);
                if (how == 2) {
                    return hour + ':' + minute;
                } else if (how == 1) {
                    return `${month}-${day}`;
                }
            },
            // 点击去供应商页面
            gosupplier(name, pkid) {
                let vm = this
                if (Cookies.get('token')) {
                    const { href } = this.$router.resolve({
                        name: 'supplierdetails',
                        query: {
                            obj: JSON.stringify({ pubname2: name, pubid: pkid, goodsType: 1 })
                        }
                    });
                    window.open(href, '_blank');
                } else {
                    this.$router.push({ name: 'Login' });
                }
            },
            //点击

            isloginRouter(name) {
                if (Cookies.get('token')) {
                    const { href } = this.$router.resolve({
                        name: name,
                    });
                    window.open(href, '_blank');
                } else {
                    this.$router.push({ name: 'Login' });
                }
            },
            isRouterHasOpt(name, key, opt) {
                let vm = this,
                    params = {};
                params[key] = opt;
                if (Cookies.get('token')) {
                    const { href } = this.$router.resolve({
                        name: name,
                        query: params
                    });
                    window.open(href, '_blank');
                } else {
                    vm.$router.push({ name: 'Login' });
                }
            },
            // 国图馆三新供货地方版
            ShowNational() {
                if (Cookies.get('token')) {
                    let doId = +localStorage.getItem('doId') + 1,
                        params = {
                            orgType: 9,
                            pageNum: 1,
                            pageSize: 36,
                        };
                    localStorage.setItem('doId', doId);
                    insertPoint(params, 'click', 'loc', doId); //添加“地方版”埋点
                    const { href } = this.$router.resolve({
                        name: 'PublisherNational',

                    });
                    window.open(href, '_blank');
                } else {
                    this.$router.push({ name: 'Login' });
                }
            },
            // 地方版百佳社
            ShowSocietys() {
                if (Cookies.get('token')) {
                    let doId = +localStorage.getItem('doId') + 1,
                        params = {
                            orgType: 8,
                            pageNum: 1,
                            pageSize: 36,
                        };
                    localStorage.setItem('doId', doId);
                    insertPoint(params, 'click', 'loc', doId); //添加“地方版”埋点
                    const { href } = this.$router.resolve({
                        name: 'PublisherNational',

                    });
                    window.open(href, '_blank');
                } else {
                    this.$router.push({ name: 'Login' });
                }
            },
            // 周边推荐
            BookTuiClickSide(item) {
                if (Cookies.get('token')) {
                    const { href } = this.$router.resolve({
                        name: 'BookDetailSide',
                        params: { goodsId: item.rowIndex }
                    });
                    window.open(href, "_blank");
                } else {
                    this.$router.push({ name: 'Login' });
                }
            },
            // 地方版出版社
            DifangAdress(item) {
                let vm = this;
                const { href } = this.$router.resolve({
                    name: 'PublisherChildsPlaces',
                    query: { id: item }
                });
                window.open(href, '_blank');
            },
            // 上面6个广告位 + 出版社推荐的广告位 + 地方版出版社的广告位（供应商）
            ShowPubLic(gid, prop, pubname, eventId, remark) {
                if (Cookies.get('token')) {
                    let params = { goodsType: 1 };
                    params[prop] = gid;
                    params.pubname2 = pubname;
                    params.pubid = remark
                    //  params.pubname = pubname;
                    params.eventId = eventId;
                    const { href } = this.$router.resolve({
                        name: 'supplierdetails',
                        query: { obj: JSON.stringify(params) }
                    });
                    window.open(href, "_blank");
                } else {
                    this.$router.push({ name: 'Login' });
                }
            },
            // 数据获取
            ApiData() {
                let vm = this;
                actionselect().then(response => {
                    //出版排行   销售排行
                    vm.pubTopArr = response.data[10] || [];//出版社排行榜
                    let d = response.data;
                    vm.SideData = d[1];//周边推荐
                    //特色推荐
                    var i = 0, j = 0;
                    j + 1 < vm.tsArr.length ? j++ : (j = 0);
                    //公共馆
                    vm.getRemList(vm.tsArr[j].gid, j);
                    //高校馆
                    var x = 0, y = 0;
                    y < vm.rmArr.length ? y++ : (y = 0);
                    //推荐书单数据
                    vm.getRmList(vm.rmArr[y].gid, y);
                    //童书类
                    var z = 0, e = 0;
                    e < vm.childrenArr.length ? e++ : (e = 0);
                    //推荐书单数据
                    vm.getRemsList(vm.childrenArr[e].gid, e);

                })
            },
            //特色推荐列表
            getRemList(activitytag = 10129, active = 0) {
                let current = Math.ceil(Math.random() * 7);
                if (active == 1) { //精品大码洋
                    current = Math.ceil(Math.random() * 3);
                }
                this.tsActive = active;
                let params = {
                    size: 8,
                    current: current,
                    sortRules: JSON.stringify({ "cbny": "desc" }),
                    activitytag
                }
                this.getHighSearch(params, 'tsListArr');
            },
            //热门推荐列表
            getRmList(activitytag = 10138, active = 0) {
                let current = Math.ceil(Math.random() * 7);
                if (active == 1) { //精品大码洋
                    current = Math.ceil(Math.random() * 3);
                }
                this.rmActive = active;
                let params = {
                    size: 8,
                    current: current,
                    sortRules: JSON.stringify({ "cbny": "desc" }),
                    activitytag
                }
                this.getHighSearch(params, 'rmListArr')
            },
            //童书类
            getRemsList(activitytag = 100001, active = 0) {
                let current = Math.ceil(Math.random() * 7);
                if (active == 1) { //精品大码洋
                    current = Math.ceil(Math.random() * 3);
                }
                this.childrenActive = active;
                let params = {
                    size: 8,
                    current: current,
                    sortRules: JSON.stringify({ "cbny": "desc" }),
                    activitytag
                }
                this.getHighSearch(params, 'childrenListArr')
            },
            getHighSearch(params, prop) {
                // console.log(params.activitytag);
                let data = bookList[params.activitytag].data,
                    entities = data.records || [];
                this[prop] = entities;
            },
            // 特色专区 （图采会专栏、类目）
            TESEtuijianTo(activityTag, name, eventId) {
                console.log(activityTag, name, eventId, 'activityTag, name, eventId');
                if (Cookies.get('token')) {
                    let params = {
                        gid: '0',
                        TitleName: name,
                        publicType: '', // 大众分类
                        cnIbraryType: '', // 中图分类
                        subjectId: '', // 学科类别
                        activityTag: activityTag, // 1精品大码洋/2畅销书/3医学/4抗疫图书/5少儿专区/6推荐书单/7工具书
                        // activityTag: '', // 经典珍藏/重磅推荐/乐活趣览
                        goodsType: 1,
                        eventId: eventId
                    };
                    const { href } = this.$router.resolve({
                        name: 'LookPublishingPagesType',
                        query: { obj: JSON.stringify(params) }
                    });
                    window.open(href, "_blank");
                } else {
                    this.$router.push({ name: 'Login' });
                }
            },
            newTESEtuijianTo(activityTag, name, eventId) {
                if (Cookies.get('token')) {
                    let params = {
                        gid: '0',
                        TitleName: name,
                        publicType: '', // 大众分类
                        cnIbraryType: '', // 中图分类
                        subjectId: '', // 学科类别
                        activityTag: activityTag, // 1精品大码洋/2畅销书/3医学/4抗疫图书/5少儿专区/6推荐书单/7工具书
                        // activityTag: '', // 经典珍藏/重磅推荐/乐活趣览
                        goodsType: 1,
                        eventId: eventId
                    };
                    const { href } = this.$router.resolve({
                        name: 'LookPublishingPagesType',
                        query: { obj: JSON.stringify(params) }
                    });
                    window.open(href, '_blank');
                } else {
                    this.$router.push({ name: 'Login' });
                }
            },
            BookTuiClickRowid(id, eventId) {
                if (Cookies.get('token')) {
                    //添加埋点
                    let doId = +localStorage.getItem('doId') + 1,
                        params = {
                            goodsId: id
                        };
                    localStorage.setItem('doId', doId);
                    insertPoint(params, 'click', eventId, doId);
                    //新页面打开书目详情
                    // this.$router.push({ name: 'BookDetail',params: { goodsId: id } });
                    const { href } = this.$router.resolve({
                        name: 'BookDetail',
                        params: { goodsId: id }
                    });
                    window.open(href, "_blank");
                } else {
                    this.$router.push({ name: 'Login' });
                }
            },
            //特色推荐排行
            async getRemTop() {
                let vm = this;
                let data = {}
                let res = await featuredrecommendationranking(data)
                if (res.code == '200') {
                    vm.remTopArr = res.data['热门推荐排行'] || [];
                } else {
                    vm.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }

            },
            goxuanchuan() {
                window.open("http://121.41.48.201:9527", "_blank");
            },
        }
    }
</script>

<style scoped lang="scss">
    .fl {
        float: left;
    }

    .fr {
        float: right;
    }

    .clearfixed:after {
        content: '';
        display: block;
        height: 0;
        line-height: 0;
        overflow: hidden;
        clear: both;
    }

    .HomePageStyle {
        width: 100%;
        background-color: #ffe6e6;
        /* #ffddb0  */
        overflow-x: hidden;
        position: relative;
        min-height: 1400px;

        /* 中国元素图 */
        .leftChinesImg {
            position: absolute;
            left: 0px;
            top: 15px;
        }

        .RighChinesImg {
            position: absolute;
            right: 0px;
            top: 0;
        }

        .container {
            width: 1310px;
            margin: 0 auto;
        }

        .part-left {
            float: left;
            width: 320px;
        }

        .part-right {
            float: right;
            width: 320px;
        }

        .part-pageimg {
            float: left;
            width: 650px;
            margin-left: 10px;
            border-radius: 4px;
            overflow: hidden;
        }

        .part-adv {
            padding: 10px 0 0;

            .adv-img {
                float: left;
                width: 320px;
                height: 195px;
                margin-right: 10px;

                &:nth-child(2n-1) {
                    margin-bottom: 10px;
                }

                >img {
                    width: 100%;
                    height: 100%;
                    border-radius: 4px;
                }
            }
        }

        .part-adv2 {
            padding: 10px 0 0;

            >.adv-img {
                float: left;
                // width: 254px;
                // height: 145px;
                width: 320px;
                height: 195px;
                margin-right: 10px;

                // &:nth-child(5n){
                &:nth-child(4n) {
                    margin-right: 0px;
                }

                >img {
                    width: 100%;
                    height: 100%;
                    border-radius: 4px;
                }
            }
        }

        .part-adv-cbs1 {
            padding: 10px 0 0;
            border-radius: 4px;
            overflow: hidden;
        }

        .part-adv-cbs2 {
            padding: 10px 0 0;

            >.cbs-img {
                float: left;
                width: 650px;
                height: 120px;
                border-radius: 4px;
                overflow: hidden;

                &:nth-child(2n-1) {
                    margin-right: 10px;
                }
            }
        }

        .part-adv-mini {

            // padding:10px 0 0;
            >.cbs-img {
                float: left;
                width: 320px;
                height: 65px;
                margin-right: 10px;
                margin-top: 10px;

                &:nth-child(4n) {
                    margin-right: 0px;
                }

                >img {
                    width: 100%;
                    height: 100%;
                    border-radius: 4px;
                }
            }
        }

        .cbs-book-wrap {
            float: left;
            width: 646px;
            margin-right: 10px;
            border: 2px solid #b30000;
            border-radius: 4px;
            margin-top: 10px;

            &:last-child {
                margin-right: 0;
            }

            .cbs-img {
                float: left;
                width: 232px;
                height: 345px;
                border-radius: 4px;
                overflow: hidden;
            }

            .cbs-book-box {
                float: left;
                width: 414px;

                >img {
                    float: left;
                    width: 133px;
                    height: 170px;
                    margin-left: 5px;
                    margin-bottom: 5px;
                    border-radius: 4px;

                    &:nth-child(n+4) {
                        margin-bottom: 0px;
                    }
                }
            }
        }

        /* 2高校馆、图书馆、出版社 */
        .University-Library {
            width: 100%;
            margin-top: 20px;
            height: 135px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        /* 6、书籍推荐 */
        .Book {
            margin-top: 20px;
            cursor: pointer;
            width: 100%;
        }

        .Book .bookTuijian {
            border-radius: 4px;
            height: 400px;
            box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.04);
            border-radius: 4px;
        }

        .Book .grid-content-one {
            overflow: hidden;
            border-radius: 4px;
            height: 400px;
            width: 100%;
            // display: flex;
            // align-items: center;
            background-color: white;

            .el-row {
                display: flex;
                justify-content: space-between;
                margin-bottom: 50px;
            }

            .content-bottom {
                width: 90%;
                margin: 0 15px;
                // margin-left: 8%;
                // height: 100px;
                line-height: 35px;

                span {
                    // margin-right: 75px;
                }
            }

            .autor_info {
                width: 640px;
                height: 180px;
                padding: 10px;
                float: left;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .Book .el-col-4 {
            height: 100%;
        }

        .ellipsis-basic {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .Book .grid-content-two {
            height: 200px;
            width: 23%;
            float: left;
            text-align: center;
            padding-left: 2%;

            p {
                &.txt {
                    font-size: 12px;
                    color: #999;
                }

                @extend .ellipsis-basic;
            }

            /* position: relative; */
            /* display: flex;
        align-items: center;
        justify-content: center; */
        }

        .Book .imgDivAdd {
            height: 150px;
            /* background-color: saddlebrown; */
            display: flex;
            align-items: center;
            justify-content: center;
            // background: url('../assets/images/moren.jpg') no-repeat center center;
            position: relative;
        }

        .error::after {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: url('../assets/images/moren.jpg') no-repeat center center;
        }

        .adress-publisher {
            width: 100%;
            margin-top: 20px;
        }

        .adress-publisher .el-col {
            border-radius: 4px;
            height: 210px;
            box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.04);
            border-radius: 4px;
        }

        .adress-content-co4 {
            border-radius: 4px;
            height: 100%;
            width: 100%;
            background-color: white;
            margin-top: 30px;
        }

        .adress-content-co4 img {
            width: 100%;
            height: 100%;
            cursor: pointer;
        }

        .adress-el-col4 {
            display: flex;
            align-items: center;
            background-color: white;
        }

        .adress-content-co14 {
            border-radius: 4px;
            width: 100%;
            cursor: pointer;
            margin-top: 5px;
            color: #000;
        }

        .adress-listStyleDiv {
            margin-right: 30px;
            min-width: 120px;
            display: inline-block;
            // padding: 0px 35px;
            color: #333;
            font-size: 16px;
            text-align: left;
            font-family: PingFangSC-Regular;
        }

        .adress-listStyleDiv:hover {
            color: #175199;
            cursor: pointer;
        }

        /* 图书销售榜 */
        .BookTuijian-el-co6 {
            position: relative;
            background-color: white;
            border-radius: 4px;
        }

        /* title */
        .BookTuijian-el-co6 .xiaoliagnTitle {
            width: 100%;
            height: 40px;
            line-height: 40px;
            position: absolute;
            top: -40px;
        }

        .BookTuijian-el-co6 .RightMore {
            position: absolute;
            right: 20px;
            color: rgba(102, 102, 102, 1);
            font-size: 14px;
            font-family: PingFangSC-Regular;
        }

        /* 排行 */
        .BookTuijian-el-co6 .DouckImg {
            display: flex;
            align-items: center;
            height: 13%;
        }

        .BookTuijian-el-co6 .nameStyle {
            color: rgba(0, 0, 0, 1);
            font-size: 14px;
            text-align: left;
            display: inline-block;
            width: 130px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }

        .BookTuijian-el-co6 .nameStyle1 {
            color: rgba(0, 0, 0, 1);
            font-size: 14px;
            text-align: left;
            display: inline-block;
            width: 215px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }

        .DouckImgWrap {
            padding: 12px;
            box-sizing: border-box;
            height: 400px;
        }

        .DouckImg {
            height: 10%;
            display: flex;
            align-items: center;
        }

        .DouckImgItem {
            width: 50px;
            display: inline-block;
            color: rgba(105, 105, 105, 1);
            font-size: 12px;
        }

        .DouckImgItem .item_not span {
            display: inline-block;
            width: 20px;
            line-height: 20px;
            color: #fff;
            background-color: #D6D2CB;
        }

        /* top1 */
        .top_item_rank_1 {
            width: 25px;
            height: 35px;
            font-weight: 600;
            color: #fff;
            position: relative;
            margin: 0px auto;
        }

        .top_item_rank_1 img {
            width: 100%;
            height: 100%;
            background-size: cover;
        }

        .top_item_rank_top {
            color: #e0a52b;
            display: block;
            width: 100%;
            text-align: center;
            position: absolute;
            z-index: 1;
            top: 2px;
            font-size: 10px;
            -webkit-transform: scale(0.8);
            transform: scale(0.8);
        }

        .top_item_rank_num {
            display: block;
            width: 100%;
            text-align: center;
            font-size: 12px;
            line-height: 18px;
            font-family: Helvetica, Arial, sans-serif;
            position: absolute;
            z-index: 1;
            top: 14px;
        }

        .biaoshi {
            height: 35px;
            max-width: 50px;
            margin-right: 5px;

            &.cbs_img {
                max-width: 190px;
                height: 40px;
            }
        }

        .banner-box {
            margin-top: 5px;

            img {
                width: 1310px;
                height: 600px;
                border-radius: 4px;
            }
        }

        .common-title {
            font-family: serif;
            height: 40px;

            // display: flex;
            // align-items: center;
            .tit_t {
                float: left;
                color: rgba(43, 39, 37, 1);
                font-size: 20px;
                font-weight: 600;
            }

            .listwrap {
                float: left;
                position: relative;
                padding: 0 20px;

                .ul_wrap {
                    height: 40px;
                    overflow: hidden;
                    transition: 0.3s all linear;
                }

                .icon {
                    position: absolute;
                    top: 12px;
                    color: #999;
                    background-color: #ffe6e6;
                }

                .icon:hover {
                    color: #ff7f00;
                }

                .iconarrowleft {
                    left: 15px;
                }

                .iconarrowright {
                    right: 0;
                }

                &.ggg_list {
                    // .ul_wrap{
                    width: 1210px;
                    // }
                }

                &.gxg_list {
                    // .ul_wrap{
                    width: 880px;
                    // }
                }

                ul {
                    overflow: hidden;
                    height: 40px;
                    width: 9999px;

                    li {
                        list-style: none;
                        outline: none;
                        float: left;
                        padding: 0 12px;
                        line-height: 40px;
                        font-size: 14px;
                        color: #666;
                        font-weight: 600;
                        cursor: pointer;

                        .three {
                            line-height: 18px !important;
                        }

                        &.active {
                            color: #ff7f00;
                        }
                    }
                }
            }
        }

        .Book {
            margin-top: 20px;
            cursor: pointer;
            width: 100%;
        }

        .Book .bookTuijian {
            // width:1180px;
            border-radius: 4px;
            height: 400px;
            box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.04);
            border-radius: 4px;
        }

        .Book .grid-content-one {
            overflow: hidden;
            border-radius: 4px;
            height: 400px;
            width: 100%;
            // display: flex;
            // align-items: center;
            background-color: white;

            .el-row {
                display: flex;
                justify-content: space-between;
                margin-bottom: 50px;
            }

            .content-bottom {
                width: 90%;
                margin: 0 15px;
                // margin-left: 8%;
                // height: 100px;
                line-height: 35px;

                span {
                    // margin-right: 75px;
                }
            }

            .autor_info {
                width: 640px;
                height: 180px;
                padding: 10px;
                float: left;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .Book .el-col-4 {
            height: 100%;
        }

        .ellipsis-basic {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .Book .grid-content-two {
            height: 200px;
            width: 23%;
            float: left;
            text-align: center;
            padding-left: 2%;

            p {
                &.txt {
                    font-size: 12px;
                    color: #999;
                }

                @extend .ellipsis-basic;
            }

            /* position: relative; */
            /* display: flex;
        align-items: center;
        justify-content: center; */
        }

        .Book .imgDivAdd {
            height: 150px;
            /* background-color: saddlebrown; */
            display: flex;
            align-items: center;
            justify-content: center;
            // background: url('../assets/images/moren.jpg') no-repeat center center;
            position: relative;
        }

        .error::after {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: url('../assets/images/moren.jpg') no-repeat center center;
        }

        // .BookTuijian-el-co18,
        // .BookTuijian-el-co6 {
        //   height: 230px;
        // }

        .grid-content-two {
            text-align: center;
        }

        .grid-content-two-title {
            color: rgba(0, 0, 0, 1);
            font-size: 14px;
            text-align: center;
        }

        .grid-content-two img {
            height: 120px;
            // height: 90px;
        }

        /* 4多元化产品 */
        .Diversification {
            width: 100%;
            margin-top: 20px;
            cursor: pointer;
        }

        /* 9周边推荐 */
        .SideTuijian {
            width: 100%;
            margin-top: 20px;
            cursor: pointer;
        }

        .SideTuijian-Book {
            border-radius: 4px;
            height: 170px;
            box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.04);
            border-radius: 4px;
            background-color: #fff;
            display: flex;
            width: 100%;
            justify-content: space-around;
        }

        .SideTuijian-grid-content {
            border-radius: 4px;
            /* height: 100%; */
            background-color: #fff;
            display: inline-block;
            width: 119px;
            height: 155px;
            padding: 20px 10px 10px;
            margin-right: 10px;
            text-align: center;
        }

        .SideTuijian-grid-content:last-child {
            margin-right: 0;
        }

        .SideTuijian-grid-content img {
            height: 110px;
            width: 110px;
        }

        .SideTuijian-grid-title {
            text-align: center;
            margin-top: 10px;
            color: rgba(0, 0, 0, 1);
            font-size: 14px;
        }

        .ad_left {
            float: left;
            width: 735px;
        }

        .ad_right {
            float: right;
            width: 424px;
        }

        .prolist .grid-content {
            width: 128px;
            display: inline-block;
            margin-right: 20px;
            margin-bottom: 20px;
            padding: 16px 0px;
            text-align: center;
            min-height: 36px;
            height: 100%;
            border-radius: 4px;
            background-color: rgba(255, 255, 255, 1);
            box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.04);
        }

        .prolist .grid-content:nth-child(3n) {
            margin-right: 0;
        }

        .grid-content img {
            width: 25px;
            height: 30px;
        }

        .Diversification .duoyuanStyle {
            font-size: 24px;
            color: rgba(196, 17, 63, 1);
            /* padding-top: 8px; */
        }

        .adv-dialog {
            width: 100%;
            height: 100%;
            position: fixed;
            top: 0;
            left: 0;
            z-index: 10000;
            background-color: rgba(0, 0, 0, 0.5);

            .dialog_close {
                width: 30px;
                height: 30px;
                background: url('../assets/images/advClose.png') no-repeat center;
                position: absolute;
                right: 20px;
                top: 20px;
                z-index: 10001;
                cursor: pointer;
            }

            .dialog_container {
                width: 1089px;
                height: 624px;
                position: absolute;
                top: 50%;
                left: 50%;
                margin-top: -312px;
                margin-left: -545px;
                z-index: 10001;
                background: url('../assets/images/30002000.png') no-repeat center;
            }
        }

        .wxcode {
            z-index: 1000;
            position: fixed;
            top: 150px;
            right: 50px;
            width: 170px;
            height: 200px;
            background-color: #fff;
            text-align: center;
            padding: 15px;

            >img {
                width: 100%;
            }
        }

        .wxcodeleft {
            z-index: 1000;
            position: fixed;
            top: 150px;
            left: 20px;
            width: 180px;
            height: 220px;
            background-color: #bd2a33;
            text-align: center;
            padding: 10px;
        }
    }

    .activestate {
        color: #e6a23c;
        background: #fdf6ec;
        border: 1px solid #f5dab1;
        font-size: 16px;
        border-radius: 3px;
        padding: 5px;
    }

    .activestate:hover {
        background: #e6a23c;
        color: #fff;
    }

    .homepage-top {
        margin: 0 auto;
        width: 100%;
        height: 40px;
        background: #fff;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, .08);
    }

    .home-page-item {
        margin: 0 auto;
        width: 1200px;
        height: 100%;
        background-color: yellowgreen;
        display: flex;
        align-items: center;
    }

    .centered-dialog {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .sidenavigationbar {
        background-color: #fff;
        position: fixed;
        top: 30%;
        right: 0px;
        justify-content: center;
        width: 90px;
        /* height: 360px; */
    }

    .sidenavigationbaritem {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        border-top: 1px solid #dcdcdc;
        border-left: 1px solid #dcdcdc;
        border-bottom: 1px solid #dcdcdc;
        border-right: 1px solid #ffe6e6;
        cursor: pointer;
        width: 100%;
        height: 80px;
        font-size: 14px;

    }
</style>


// WEBPACK FOOTER //
// src/views/Home-Page.vue